// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { rectangleLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-rectangle-lines': IconRectangleLines;
    }
}

/**
 * The icon component for the 'rectangleLines' icon
 */
export class IconRectangleLines extends IconSvg {
    public constructor() {
        super(rectangleLines16X16);
    }
}

registerIconSvg('icon-rectangle-lines', IconRectangleLines);
export const iconRectangleLinesTag = 'nimble-icon-rectangle-lines';
